"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9379],{

/***/ 57669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SvgParslyLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 139 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M19.557 18.667a1.54 1.54 0 00-.38-.519c-.192-.19-.383-.382-.573-.572-.26-.26-.518-.525-.78-.786l-.878-.875c-.288-.287-.572-.575-.853-.862-.268-.27-.534-.534-.801-.805-.268-.27-.554-.565-.832-.845-.32-.32-.64-.63-.954-.96a1.326 1.326 0 00-.853-.411 1.41 1.41 0 00-1.19.448c-.123.13-.253.256-.38.384-.413.413-.83.823-1.243 1.238-.974.977-1.945 1.955-2.915 2.933-.393.394-.789.79-1.181 1.187a.948.948 0 00-.288.447.225.225 0 01-.066.114c-.023.02-.065.02-.1.03v.868a.4.4 0 00.08-.016c.014.018.033.027.037.043.08.249.221.474.41.656.278.284.556.565.836.843.296.3.595.6.895.899l.497.496c.261.26.524.518.784.78.278.28.553.569.832.854l1.256 1.264c.186.185.371.37.561.547a1.257 1.257 0 00.949.373c.106-.005.213 0 .32 0 .053.006.107 0 .159-.015.229-.076.44-.2.617-.363.511-.534 1.04-1.051 1.56-1.574.706-.707 1.41-1.42 2.116-2.126.657-.655 1.313-1.312 1.967-1.969.243-.228.41-.526.478-.853a1.46 1.46 0 00-.087-.853zm-6.836 4.063c-.07.069-.143.132-.213.2a.553.553 0 01-.107-.063c-1.17-1.172-2.337-2.346-3.502-3.52a.749.749 0 01-.067-.097c.03-.044.063-.087.098-.128.705-.754 3.381-3.413 3.591-3.571.083.073.174.144.254.224.275.274.543.553.815.827.272.274.547.547.82.82a329.227 329.227 0 001.673 1.685.964.964 0 00.143.092c-1.202 1.212-2.36 2.374-3.505 3.533v-.002zM39.44 19.282v-.258a1.035 1.035 0 00-.286-.706c-.213-.252-.47-.474-.705-.71-.397-.394-.794-.787-1.188-1.181-.395-.395-.756-.771-1.14-1.152-.4-.402-.81-.797-1.21-1.198a96.585 96.585 0 01-1.585-1.59 1.387 1.387 0 00-.788-.427 1.423 1.423 0 00-.665.028c-.34.107-.594.332-.844.568-.19.18-.372.37-.556.554l-1.55 1.55-.88.878c-.287.287-.576.572-.86.864-.282.293-.555.59-.838.88-.282.29-.563.56-.841.842a1.35 1.35 0 00-.398 1.348c.068.289.219.551.433.756.045.042.09.087.134.132l1.53 1.53.9.899.86.853c.262.26.527.518.787.78.395.395.783.799 1.184 1.187.158.173.332.33.52.468.207.145.45.227.703.234h.325a.96.96 0 00.533-.177c.151-.11.294-.232.427-.364.782-.775 1.561-1.553 2.337-2.332 1.072-1.067 2.144-2.137 3.215-3.212.105-.11.199-.23.278-.36.133-.202.193-.443.169-.684zm-3.626.139a485.003 485.003 0 00-1.955 1.946c-.484.486-.968.97-1.453 1.454a.725.725 0 01-.121.092c-.03-.01-.05-.015-.058-.029-1.192-1.188-2.385-2.38-3.578-3.577-.022-.025-.042-.055-.063-.08.133-.187 3.384-3.452 3.677-3.69.05.043.107.083.155.132.626.623 1.252 1.248 1.877 1.875l1.494 1.493c.056.055.106.114.175.185-.045.07-.095.136-.149.199zM29.547 10.177a.335.335 0 010-.08c.017-.287-.107-.523-.265-.747a5.227 5.227 0 00-.567-.614c-.275-.277-.555-.562-.832-.843-.278-.28-.587-.584-.88-.879-.294-.294-.573-.57-.86-.853-.287-.283-.55-.547-.824-.821l-.878-.88c-.285-.29-.566-.584-.86-.861a3.421 3.421 0 00-.503-.399.988.988 0 00-.656-.146h-.125a1.143 1.143 0 00-.898.35c-.118.106-.23.228-.344.343-.283.28-.567.556-.847.835-.4.4-.795.806-1.2 1.207-.618.618-1.24 1.23-1.857 1.85-.511.51-1.012 1.026-1.524 1.534a1.42 1.42 0 00-.446 1.11c.009.344.15.672.392.917.401.401.805.8 1.206 1.201.532.53 1.06 1.058 1.588 1.587.64.646 1.283 1.29 1.93 1.934.382.38.76.77 1.15 1.144.233.229.547.358.874.358a1.511 1.511 0 001.13-.475c.412-.417.826-.83 1.24-1.245l.86-.853c.286-.283.589-.583.882-.877l.747-.746c.29-.294.582-.59.874-.883l1.151-1.145a.768.768 0 00.112-.152c.16-.27.275-.55.23-.87zm-3.563.117l-3.584 3.6a.202.202 0 01-.051.007.033.033 0 01-.023-.012c-.244-.24-.488-.479-.73-.721l-2.87-2.894c-.01-.012-.01-.032-.02-.058a.448.448 0 01.059-.084l3.552-3.552c.018-.018.048-.022.072-.036.025.01.05.021.072.036l3.52 3.51c.029.036.055.074.077.115a.708.708 0 01-.07.09h-.004z",
    fill: "#29A776"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M64.373 9.823a7.146 7.146 0 00-.307-1.948c-.668-2.143-2.036-3.666-4.169-4.501-.991-.39-2.026-.533-3.093-.544-.916-.014-1.833-.01-2.75-.01-1.68 0-3.36.006-5.04.008h-1.716a.427.427 0 00-.267.04.855.855 0 00-.03.363V23.02c.007.056.02.11.035.164.12 0 .226.01.334.01h3.353a.963.963 0 00.162-.034c0-.118.007-.224.007-.33v-4.977-.454a1.21 1.21 0 01.034-.166h.331c1.942-.013 3.885.025 5.829-.022.7-.01 1.395-.107 2.07-.287 2.015-.552 3.52-1.73 4.45-3.576a7.308 7.308 0 00.767-3.525zm-4.244 1.964c-.488.987-1.302 1.576-2.383 1.823-.31.068-.627.101-.945.099h-5.553a.7.7 0 01-.32-.031.261.261 0 01-.027-.08V6.624a.681.681 0 01.024-.113c.055-.009.106-.017.16-.021.053-.005.09 0 .134 0h5.554c.445-.005.888.06 1.312.194 1.029.333 1.755.992 2.154 1.975a3.669 3.669 0 01-.11 3.128zM81.173 9.067a.908.908 0 00-.025-.149c-.23-.033-3.138-.036-3.413 0a2.76 2.76 0 00-.035.458c-.01.153-.024.304-.033.454-.008.15-.01.32-.025.48a1.912 1.912 0 01-.067.468c-.06-.073-.1-.12-.134-.169a4.125 4.125 0 00-1.048-1.038 5.908 5.908 0 00-3.13-1.031 9.206 9.206 0 00-1.306.035 8.15 8.15 0 00-2.718.712 6.391 6.391 0 00-3.033 2.886c-.54 1.033-.787 2.14-.853 3.29-.03.533-.018 1.068.034 1.6.065.765.234 1.519.5 2.24.654 1.712 1.813 2.96 3.526 3.699a7.45 7.45 0 002.095.558 8.119 8.119 0 001.764.06 6.764 6.764 0 002.29-.64c.807-.39 1.494-.917 1.946-1.694.014-.024.045-.04.084-.071.079.34.067.662.106.98.04.316.048.65.1.988.106 0 .196.01.286.01h2.783a.59.59 0 00.306-.046c0-.113.007-.226.007-.34V9.28c-.007-.07-.007-.14-.007-.213zm-4.16 9.173a3.864 3.864 0 01-2.681 2.043c-.898.21-1.839.15-2.703-.172-1.234-.457-2.055-1.315-2.454-2.544a4.867 4.867 0 01-.007-3.05c.413-1.28 1.28-2.155 2.582-2.587a4.725 4.725 0 012.942-.031A3.829 3.829 0 0177 13.819a4.758 4.758 0 01.013 4.421zM117.491 8.92c.232-.036 3.909-.036 4.154 0 .409 1.11.804 2.24 1.21 3.36.407 1.122.8 2.234 1.195 3.355s.775 2.26 1.173 3.403c.107-.072.12-.175.153-.26.339-.874.677-1.749 1.004-2.628.426-1.155.933-2.28 1.411-3.413.499-1.185 1.006-2.367 1.509-3.552.037-.09.079-.18.12-.272.263-.025.527-.031.791-.02h2.367a6.85 6.85 0 01.783.016c0 .029.015.049.008.062l-8.781 20.026c-.026.056-.059.107-.089.165a.81.81 0 01-.113.018h-3.705a.293.293 0 01-.075-.02c-.042-.1.026-.175.06-.256.291-.672.588-1.341.881-2.011.528-1.203 1.055-2.406 1.581-3.61.043-.097.084-.196.132-.307-.079-.193-.158-.392-.24-.589-1.253-3.03-2.507-6.057-3.76-9.084-.575-1.385-1.149-2.771-1.721-4.16-.026-.068-.077-.137-.048-.224zM96.311 21.132c.591-.84 1.166-1.661 1.755-2.497.055.045.093.079.13.115a6.007 6.007 0 001.654 1.067c.766.353 1.577.6 2.41.732.529.098 1.07.105 1.6.018.421-.07.823-.227 1.18-.46.218-.144.4-.334.533-.558a1.25 1.25 0 00.126-1.032 1.103 1.103 0 00-.533-.648 2.84 2.84 0 00-.865-.308 7.968 7.968 0 00-1.241-.16 13.182 13.182 0 01-2.074-.279 7.394 7.394 0 01-2.298-.877 4.017 4.017 0 01-1.273-1.186 3.534 3.534 0 01-.578-1.652 4.298 4.298 0 01.084-1.435 3.722 3.722 0 011.346-2.08 6.025 6.025 0 012.04-1.039 9.563 9.563 0 013.065-.38c.744.014 1.484.106 2.209.274a7.194 7.194 0 012.963 1.523.93.93 0 01.073.076c-.107.177-1.688 2.026-1.965 2.29-.107 0-.153-.083-.219-.137a4.463 4.463 0 00-1.877-.931 6.057 6.057 0 00-.854-.142c-.64-.049-1.289-.055-1.92.093a4.39 4.39 0 00-.617.204c-.116.049-.226.112-.328.187a1.161 1.161 0 00-.099 1.8c.158.137.335.248.526.33.291.127.599.214.913.258.359.05.719.086 1.083.115.915.07 1.824.171 2.71.426a6.011 6.011 0 011.545.653 3.621 3.621 0 011.747 2.618 4.875 4.875 0 01-.036 1.857 4.185 4.185 0 01-1.585 2.425 5.972 5.972 0 01-2.223 1.033 9.379 9.379 0 01-1.532.239 13.36 13.36 0 01-2.148-.02 8.518 8.518 0 01-3.259-.88 8.314 8.314 0 01-2.063-1.513.684.684 0 01-.105-.12zM87.834 23.166c-.266.04-3.312.04-3.558 0a1.189 1.189 0 01-.027-.146V9.28c0-.115 0-.228.006-.346a.696.696 0 01.307-.035h2.806c.062 0 .123.012.202.018.118.511.158 1.032.28 1.583.072-.09.12-.142.16-.197.211-.302.459-.577.737-.82a3.828 3.828 0 011.98-.885c.366-.058.737-.09 1.109-.095 1.166 0 2.269.255 3.26.877.159.103.312.215.458.334.051.045.099.094.142.146-.081.235-1.476 2.867-1.618 3.053-.077-.055-.158-.107-.235-.167a3.413 3.413 0 00-1.28-.621 4.576 4.576 0 00-1.297-.107c-.38.017-.757.081-1.122.19-1.074.34-1.781 1.03-2.109 2.093-.129.426-.192.87-.189 1.316v7.194l-.012.355zM115.228 23.16c-.253.044-1.555.058-3.297.034-.079 0-.16-.012-.25-.018a1.335 1.335 0 01-.02-.167V3.281a1.5 1.5 0 01.018-.354c.052-.009.095-.02.137-.022.452-.024 3.182-.007 3.389.022.013.048.023.097.03.146v19.728c-.001.115-.005.23-.007.36z",
    fill: "#101827"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgParslyLogo);

/***/ }),

/***/ 90661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sign_up_SignUpLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./src/components/share/image-app.tsx
var image_app = __webpack_require__(69726);
;// CONCATENATED MODULE: ./src/components/login/components/styles.ts
var footerWrapper = {
    position: "sticky",
    top: "100%",
    p: "10rem 0 6rem",
    background: "#000",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    "@media (min-width: 560px)": {
        padding: "7.4rem 0 8rem"
    }
};
var footerContent = {
    display: "flex",
    flexDirection: "column",
    maxWidth: "116.8rem",
    padding: "0 3.6rem",
    flex: 1,
    "@media (min-width: 560px)": {
        flexDirection: "row",
        flexWrap: "nowrap"
    }
};
var footerLinks = {
    px: "0.8rem",
    "@media (min-width: 560px)": {
        flex: "0 0 33.3333%"
    },
    "@media (min-width: 1080px)": {
        flex: "0 0 50%"
    }
};
var footerMenu = {
    flex: "0 0 33.3333%",
    pt: "6.6rem",
    px: "0.8rem",
    "@media (min-width: 560px)": {
        maxWidth: "33%",
        pt: "1.8rem"
    },
    "@media (min-width: 1080px)": {
        flex: "0 0 25%"
    }
};
var footerMenuItem = {
    fontSize: "1.3rem",
    fontWeight: 400,
    lineHeight: "1.6rem",
    fontFamily: "NexaRegular",
    "&:not(:first-of-type)": {
        mt: "1.5rem"
    }
};
var footerLink = {
    textDecoration: "none",
    cursor: "pointer",
    fontFamily: "NexaBold",
    color: function(theme) {
        return theme.palette.primary.contrastText;
    }
};

;// CONCATENATED MODULE: ./src/components/login/components/Footer.tsx





var Footer = function() {
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var FooterMenuItems = {
        left: [
            {
                key: "menu-item-474",
                link: t("footer__faq_link"),
                text: t("footer__faq")
            },
            {
                key: "menu-item-140",
                link: t("footer__careers_link"),
                text: t("footer__careers")
            },
            {
                key: "menu-item-730",
                link: t("footer__termsAndConditions_link"),
                text: t("footer__termsAndConditions")
            },
            {
                key: "menu-item-979",
                link: t("footer__cookiesAndPrivacy_link"),
                text: t("footer__cookiesAndPrivacy")
            }, 
        ],
        right: [
            {
                key: "footer-tel",
                link: "tel:".concat(t("footer__phoneNumber")),
                text: t("footer__phoneNumber")
            },
            {
                key: "footer-email",
                link: "mailto:".concat(t("footer__email")),
                text: t("footer__email")
            },
            {
                key: "footer-orgName",
                link: null,
                text: t("footer__orgName")
            },
            {
                key: "footer-orgNumber",
                link: null,
                text: t("footer__orgNumber")
            }, 
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: footerWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: footerContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: footerLinks,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_app/* ImageApp */.U, {
                            style: {
                                maxWidth: "10.6rem"
                            },
                            mainImage: "https://cdn.parsly.com/images/parsly-logo-white.svg"
                        })
                    })
                }),
                Object.keys(FooterMenuItems).map(function(key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: footerMenu,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: FooterMenuItems[key].map(function(menu) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: footerMenuItem,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: menu.link,
                                        sx: footerLink,
                                        children: menu.text
                                    })
                                }, menu.key);
                            })
                        })
                    }, "footerMenuItems-".concat(key));
                })
            ]
        })
    });
};
/* harmony default export */ var components_Footer = (Footer);

// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
;// CONCATENATED MODULE: ./src/components/layout/login/sign-up/styles.ts


var backgroundPaper = function(theme) {
    return theme.palette.background.paper;
};
var displayFlex = {
    display: "flex"
};
var justifyCenter = {
    justifyContent: "center"
};
var flexOne = 1;
var pageWrapper = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, displayFlex), {
    flexDirection: "column",
    flex: flexOne,
    background: backgroundPaper,
    "@media (min-width: 769px)": (0,_object_spread/* default */.Z)({
        flexDirection: "row"
    }, justifyCenter)
});

;// CONCATENATED MODULE: ./src/components/layout/login/sign-up/SignUpLayout.tsx




var SignUpLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: pageWrapper,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Footer, {})
        ]
    });
};
/* harmony default export */ var sign_up_SignUpLayout = (SignUpLayout);


/***/ }),

/***/ 13395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ left_message_LeftSideMessage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./public/img/icons/parsly-logo.svg
var parsly_logo = __webpack_require__(57669);
// EXTERNAL MODULE: ./src/icons/solid-mail.tsx
var solid_mail = __webpack_require__(76754);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
;// CONCATENATED MODULE: ./src/components/login/left-message/styles.ts


var backgroundPaper = function(theme) {
    return theme.palette.background.paper;
};
var backgroundDefault = function(theme) {
    return theme.palette.background.default;
};
var displayFlex = {
    display: "flex"
};
var justifyCenter = {
    justifyContent: "center"
};
var flexOne = 1;
var ParslyWrapper = {
    display: "flex",
    flex: flexOne,
    background: backgroundDefault,
    "@media (min-width: 769px)": {
        flex: "0 0 50%",
        justifyContent: "end"
    }
};
var ParslyBoxContent = {
    p: "4rem 2.4rem",
    "@media (min-width: 769px)": {
        maxWidth: "79.2rem",
        p: "10.4rem 4.8rem 10.8rem 12rem"
    }
};
var ParslyLogoWrapper = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
    fontSize: 0
}, displayFlex, justifyCenter), {
    height: "6.4rem",
    width: "20rem",
    "@media (min-width: 769px)": {
        justifyContent: "flex-start"
    }
});
var ContactUsBox = {
    display: "none",
    "@media (min-width: 769px)": {
        mt: "6.4rem",
        display: "block"
    }
};
var ContactIconWrapper = {
    borderRadius: ".8rem",
    backgroundColor: function(theme) {
        return theme.palette.primary.main;
    },
    mr: "1.6rem"
};
var EmailIconStyles = {
    color: backgroundPaper,
    fontSize: "2.4rem"
};
var ContactLink = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, displayFlex), {
    textDecoration: "none",
    alignItems: "center",
    color: function(theme) {
        return theme.palette.text.primary;
    }
});

// EXTERNAL MODULE: ./src/utils/i18n.ts + 5 modules
var i18n = __webpack_require__(27957);
;// CONCATENATED MODULE: ./src/components/login/left-message/LeftSideMessage.tsx








var LeftSideMessage = function(param) {
    var title = param.title, message = param.message, secondText = param.secondText;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: ParslyWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            sx: ParslyBoxContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: ParslyLogoWrapper,
                    "data-testid": "parsly-logo-sidebar",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(parsly_logo/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: ContactUsBox,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "https://parsly.com/".concat(i18n/* default.language */.Z.language === "en" ? "en/contact-us/#:~:text=write%20a%20message.-,Name,-Email%20or%20phone" : "kontakt/#:~:text=skriv%20ett%20meddelande.-,Namn,-E%2Dpost%20eller"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                            sx: ContactLink,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                    sx: ContactIconWrapper,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(solid_mail/* SolidMail */.g, {
                                        sx: EmailIconStyles
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "overline",
                                    children: t("login_page__contact-us")
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        mt: "4.8rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h1",
                            children: t(title)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "textSecondary",
                            variant: "body1",
                            sx: {
                                mt: ".8rem"
                            },
                            children: t(message)
                        }),
                        secondText ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "textSecondary",
                            variant: "body1",
                            children: t(secondText)
                        }) : null
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var left_message_LeftSideMessage = (LeftSideMessage);


/***/ }),

/***/ 57858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83321);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98456);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61214);





var AppButton = function(props) {
    var classes = useStyles();
    var btnProps = function(props) {
        var newP = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, props);
        delete newP.loading;
        return newP;
    };
    return props.loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, btnProps(props)), {
        disabled: true,
        className: classes.appButton,
        startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            size: 20
        })
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        className: classes.appButton
    }, btnProps(props)));
};
/* harmony default export */ __webpack_exports__["Z"] = (AppButton);
var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
    return {
        appButton: {
            borderRadius: "3.2rem",
            zIndex: 1
        }
    };
});


/***/ }),

/***/ 69726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ ImageApp; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _utils_image_url__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72221);





var ImageApp = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isBroken = ref1[0], setIsBroken = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsBroken(false);
    }, [
        props.mainImage
    ]);
    var onLoad = function() {
        setLoading(false);
    };
    var imgTagOriginAttr = function(props) {
        var newP = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props);
        delete newP.mainImage;
        delete newP.brokenImg;
        delete newP.defaultImg;
        return newP;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, imgTagOriginAttr(props)), {
                style: {
                    opacity: "0.2"
                },
                src: props.defaultImg,
                alt: ""
            })) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, imgTagOriginAttr(props)), {
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                    display: !loading ? "" : "none",
                    opacity: props.opacity ? props.opacity : isBroken ? "0.2" : "1"
                }, props.style),
                src: props.mainImage,
                onLoad: function() {
                    return onLoad();
                },
                onError: function(e) {
                    setIsBroken(true);
                    return (0,_utils_image_url__WEBPACK_IMPORTED_MODULE_4__/* .imageOnError */ .F)(e, props.brokenImg);
                },
                alt: ""
            }))
        ]
    });
};



/***/ }),

/***/ 76754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ SolidMail; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);


var SolidMail = (0,_mui_material_utils__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M2.40356 7.06085L12 11.8584L21.5964 7.06085C21.5608 6.44938 21.2929 5.87463 20.8473 5.45432C20.4018 5.03401 19.8125 4.79994 19.2 4.80005H4.79996C4.18747 4.79994 3.5981 5.03401 3.15258 5.45432C2.70705 5.87463 2.43909 6.44938 2.40356 7.06085Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M21.6 9.7417L12 14.5417L2.40002 9.7417V16.8001C2.40002 17.4366 2.65288 18.0471 3.10297 18.4972C3.55306 18.9472 4.1635 19.2001 4.80002 19.2001H19.2C19.8365 19.2001 20.447 18.9472 20.8971 18.4972C21.3472 18.0471 21.6 17.4366 21.6 16.8001V9.7417Z",
            fill: "currentColor"
        })
    ]
}), "SolidMail");


/***/ }),

/***/ 72221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ imageOnError; }
/* harmony export */ });
/* unused harmony export getImageUrl */
var getImageUrl = function(resource, id) {
    return "https://cdn.parsly.com/images/".concat(resource, "/").concat(id, ".png");
};
var imageOnError = function(e, defaultImagePath) {
    if (e.target.src !== window.location.origin + defaultImagePath) {
        e.target.src = defaultImagePath;
    }
};


/***/ })

}]);